import React from 'react';
import styled from 'styled-components';
import { message } from 'antd';
import { useDispatch } from 'react-redux';
import { TuroReservationPageList } from './list';
import { TTuroReservation } from '../start-work-order/type';
import { setLoading } from '../../redux/slices/appInfo';
import { getTuroReservations } from '../../api/setting/turo-reservations';

const Wrapper = styled.div``;

export const TuroReservationsPage: React.FC = () => {
    const dispatch = useDispatch();
    const [reservations, setReservations] = React.useState<TTuroReservation[]>(
        []
    );
    const [total, setTotal] = React.useState(0);
    const [page, setPage] = React.useState(1);
    const [pageSize, setPageSize] = React.useState(10);
    const [search, setSearch] = React.useState('');

    const onLoadData = React.useCallback(
        async (
            pageNum: number = page,
            pageSizeNum: number = pageSize,
            searchText: string = search
        ) => {
            try {
                dispatch(setLoading(true));
                const result = await getTuroReservations(
                    pageNum,
                    pageSizeNum,
                    searchText
                );
                if (result?.data) {
                    setReservations(result.data.data ?? []);
                    setTotal(result.data.total ?? 0);
                    setPage(result.data.page ?? 1);
                    setPageSize(result.data.pageSize ?? 10);
                }
            } catch {
                message.error('Failed to load Turo reservations');
            } finally {
                dispatch(setLoading(false));
            }
        },
        [dispatch, page, pageSize, search]
    );

    const onReload = React.useCallback(() => {
        onLoadData(1, pageSize, search);
    }, [onLoadData, pageSize, search]);

    React.useEffect(() => {
        onLoadData(1, 10);
    }, []);

    const onChangePage = React.useCallback(
        (newPage: number, newPageSize?: number) => {
            onLoadData(newPage, newPageSize || pageSize, search);
        },
        [onLoadData, pageSize, search]
    );

    const onSearch = React.useCallback(
        (searchText: string) => {
            const nextSearch = searchText.trim();
            setSearch(nextSearch);
            onLoadData(1, pageSize, nextSearch);
        },
        [onLoadData, pageSize]
    );

    return (
        <Wrapper className="flex flex-col items-center justify-start h-full">
            <div className="flex flex-row items-start h-full w-full">
                <TuroReservationPageList
                    reservations={reservations}
                    total={total}
                    page={page}
                    pageSize={pageSize}
                    onChangePage={onChangePage}
                    onReload={onReload}
                    search={search}
                    onSearch={onSearch}
                />
            </div>
        </Wrapper>
    );
};
